import React, { Component } from 'react';

var Tumbler = React.createClass({
  getInitialState: function () {
    return({status: false})
  },
  activeOrDisableTumbler: function(){
    this.props.changer(!this.state.status, this.props.type)
    this.setState({status: !this.state.status})
  },
  render: function(){
    return(
      <div onClick={this.activeOrDisableTumbler} className={"tumbler" + (this.props.open ? ' active' : '')}>
        <div className="panel"></div>
      </div>
    );
  }
});

export default Tumbler;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Filter/Tumbler/index.jsx
 **/